import { AugustTrainwreck } from "../../../../src/data/articles/the-best-0-3-0-6-draft-of-my-life/sample-decks/AugustTrainwreck.tsx";
import { JanuaryDeck } from "../../../../src/data/articles/the-best-0-3-0-6-draft-of-my-life/sample-decks/JanuaryDeck.tsx";
import { WinnerOne } from "../../../../src/data/articles/the-best-0-3-0-6-draft-of-my-life/sample-decks/WinnerOne.tsx";
import { WinnerTwo } from "../../../../src/data/articles/the-best-0-3-0-6-draft-of-my-life/sample-decks/WinnerTwo.tsx";
import * as React from 'react';
export default {
  AugustTrainwreck,
  JanuaryDeck,
  WinnerOne,
  WinnerTwo,
  React
};